// Main.js
import "./Main.css";
import React, { useContext } from "react";
import NewsGallery from "../NewsGallery/NewsGallery";
import Vacancies from "../Vacancies/Vacancies";
import CurrentMonthCalendar from "./MainCalendarV2/CurrentMonthCalendar";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/CurrentUserContext";
import { canAccessOnboardingWelcome } from "../../utils/onboardingAccess";
// import CalendarComponent from "./MainCalendar/CalendarSection/CalendarSection";
// import MainNav from "../MainNav/MainNav";

const months = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

function Main() {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const now = new Date();
  const monthTitle = `${months[now.getMonth()]} ${now.getFullYear()}`;
  const shouldShowWelcomeBlock = canAccessOnboardingWelcome(userData);

  return (
    <section className="main">
      {shouldShowWelcomeBlock && (
        <div className="main__welcome-block">
          <div className="main__welcome-marquee">
            <div className="main__welcome-marquee-track">
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
              <span>Добро пожаловать в AQMOL-project!</span>
            </div>
          </div>
          <div className="main__welcome-card">
            <div className="main__welcome-content">
              <div className="main__welcome-badge">Для новых сотрудников</div>
              <h3 className="main__welcome-title">
                Добро пожаловать в AQMOL-project!
              </h3>
              <p className="main__welcome-text">
                Вводные материалы помогут быстро освоиться в компании и портале
              </p>
            </div>
            <button
              type="button"
              className="main__welcome-button"
              onClick={() => navigate("/onboarding-materials")}
            >
              Посмотреть материалы
            </button>
          </div>
        </div>
      )}
      <div className="main__columns">
        <div className="main__news-block">
          <NewsGallery />
        </div>
        <div className="main__calendar-block">
          <h2 className="main__title">{monthTitle}</h2>
          <CurrentMonthCalendar />
        </div>
      </div>
      <div className="main__vacancies-block">
        <Vacancies />
      </div>
    </section>
  );
}

export default Main;
